module.exports = __webpack_public_path__ + "img/cpu.390a2bef.svg";